module.exports = __webpack_public_path__ + "static/media/photo-right-fifth.d353ec24.png";